import React, { FunctionComponent, useState } from 'react';
import { useForm } from 'react-hook-form';

import { SubmitButton } from 'components';

import { toCurrencyWithSign } from 'scenes/common/helpers/currency';
import { InputFormatQuestion } from 'scenes/common/components/Questions';
import { SingleFieldStepProps, ValueRange } from 'scenes/common/types';
import HelpTextModal from './HelpTextModal/HelpTextModal';

const STATE_KEY = 'agreedBuildingSumInsured';

const AGREED_VALUE_MAX_LENGTH = 9;
export const AGREED_VALUE_QUESTION =
  'For what value would you like to insure the building?';
const HELP_LINK_CAPTION = 'What is considered as rebuilding costs?';

const SumInsuredBuildingStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'defaultStateValue' | 'onNext'> & {
    valueRange: ValueRange;
  }
> = ({ onNext, defaultStateValue, valueRange }) => {
  const { formState: hooksForm, handleSubmit, errors, control } = useForm({
    mode: 'onChange',
    criteriaMode: 'all',
  });
  const [showModal, setShowModal] = useState(false);

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <InputFormatQuestion
        size={4}
        prefix="$"
        errors={errors}
        ariaRequired
        placeholder="$0"
        decimalScale={0}
        control={control}
        stateKey={STATE_KEY}
        question={AGREED_VALUE_QUESTION}
        maxLength={AGREED_VALUE_MAX_LENGTH}
        defaultValue={defaultStateValue}
        helpLink={{
          id: 'what-is-considered-as-rebuilding-costs-link',
          text: HELP_LINK_CAPTION,
          ariaLabel: `${HELP_LINK_CAPTION} Opens dialog`,
          onClick: () => setShowModal(true),
        }}
        validationRules={{
          validate: {
            validField: (value) =>
              (parseInt(value, 10) >= parseInt(valueRange.lowerLimit, 10) &&
                parseInt(value, 10) <= parseInt(valueRange.upperLimit, 10)) ||
              `You can enter a Sum Insured value between ${toCurrencyWithSign(
                valueRange.lowerLimit
              )} and ${toCurrencyWithSign(valueRange.upperLimit)}.`,
          },
        }}
      />
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
      <HelpTextModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </form>
  );
};

export default SumInsuredBuildingStep;
